import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from 'views/Main'
Vue.use(VueRouter)

// 解决重复点击跳转报错
// const originalPush = VueRouter.prototype.originalPush
// VueRouter.prototype.push = function push(location){
//   return originalPush.call(this,location).catch( err => err)
// }

const routes = [
  {
    path: '',
    redirect: 'main'
  },
  {
    path: '/main',
    component:Main,
    children: [
      {
        path: '',
        redirect: 'index',
        meta:{
          title:'首页'
        }
      },
      {
        path: 'index',
        name:'index',
        component: () => import('views/index/Index'),
        meta:{
          title:'首页'
        }
      },
      {
        path: 'wbao',
        name:'wbao',
        component: () => import('views/index/Wbao'),
        meta:{
          title:'首页'
        }
      },
      {
        path: 'televy',
        name:'televy',
        component: () => import('views/index/Televy'),
        meta:{
          title:'首页'
        }
      },
      {
        path: 'attest',
        name:'attest',
        component: () => import('views/attest/Index'),
        meta:{
          title:'身份认证'
        }
      },
      {
        path: 'scenic',
        name:'scenic',
        component: () => import('views/scenic/Index'),
        meta:{
          title:'景区'
        }
      },
      {
        path: 'scenicDetail',
        name:'scenicDetail',
        component: () => import('views/scenic/Detail'),
        meta:{
          title:'景区详情'
        }
      },
      {
        path: 'sceniCard',
        name:'sceniCard',
        component: () => import('views/scenic/Card'),
        meta:{
          title:'买卡'
        }
      },
      {
        path: 'scenicPay',
        name:'scenicPay',
        component: () => import('views/scenic/Payment'),
        meta:{
          title:'购卡详情'
        }
      },

      {
        path: 'specialCard',
        name:'specialCard',
        component: () => import('views/special/Card'),
        meta:{
          title:'买卡'
        }
      },
      {
        path: 'specialPay',
        name:'specialPay',
        component: () => import('views/special/Payment'),
        meta:{
          title:'购卡详情'
        }
      },
      

      {
        path: 'play1',
        name:'play1',
        component: () => import('views/video/Play1'),
        meta:{
          title:'入园流程'
        }
      },

      {
        path: 'scenicOrder',
        name:'scenicOrder',
        component: () => import('views/scenic/Order'),
        meta:{
          title:'我的订单'
        }
      },

      {
        path: 'ticket',
        name:'ticket',
        component: () => import('views/scenic/Ticket'),
        meta:{
          title:'验票员'
        }
      },
      {
        path: 'park',
        name:'park',
        component: () => import('views/scenic/Park'),
        meta:{
          title:'入园抵扣'
        }
      },
      {
        path: 'code',
        name:'code',
        component: () => import('views/scenic/Code'),
        meta:{
          title:'实卡激活'
        }
      },

      {
        path: 'img',
        name:'img',
        component: () => import('views/scenic/Img'),
        meta:{
          title:'青秀山入园二维码'
        }
      },

      {
        path: 'codery',
        name:'codery',
        component: () => import('views/scenic/Codery'),
        meta:{
          title:'入园'
        }
      },

      {
        path: 'smanage',
        name:'smanage',
        component: () => import('views/scenic/Manage'),
        meta:{
          title:'景区管理端'
        }
      },
      {
        path: 'role',
        name:'role',
        component: () => import('views/scenic/Role'),
        meta:{
          title:'景区管理员'
        }
      },

      {
        path: 'roleadd',
        name:'roleadd',
        component: () => import('views/scenic/Roleadd'),
        meta:{
          title:'编辑管理员'
        }
      },

      {
        path: 'ticketype',
        name:'ticketype',
        component: () => import('views/scenic/Ticketype'),
        meta:{
          title:'景区门票管理'
        }
      },

      {
        path: 'ticketadd',
        name:'ticketadd',
        component: () => import('views/scenic/Ticketadd'),
        meta:{
          title:'门票编辑'
        }
      },

      {
        path: 'entry',
        name:'entry',
        component: () => import('views/scenic/Entry'),
        meta:{
          title:'入园数据分析'
        }
      },

      {
        path: 'morder',
        name:'morder',
        component: () => import('views/scenic/Morder'),
        meta:{
          title:'景区订单数据分析'
        }
      },

      {
        path: 'finance',
        name:'finance',
        component: () => import('views/scenic/Finance'),
        meta:{
          title:'财务数据分析'
        }
      },
      {
        path: 'garden',
        name:'garden',
        component: () => import('views/scenic/Garden'),
        meta:{
          title:'我的进园情况'
        }
      },


      {
        path: 'mine',
        name:'mine',
        component: () => import('views/mine/Index'),
        meta:{
          title:'个人中心'
        }
      },
      {
        path: 'tmine',
        name:'tmine',
        component: () => import('views/mine/Tindex'),
        meta:{
          title:'个人中心'
        }
      },
      {
        path: 'card',
        name:'card',
        component: () => import('views/mine/Detail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'cash',
        name:'cash',
        component: () => import('views/cash/Index'),
        meta:{
          title:'我的实体卡'
        }
      },
      {
        path: 'order',
        name:'order',
        component: () => import('views/order/Index'),
        meta:{
          title:'订单列表'
        }
      },
      {
        path: 'oDetail',
        name:'oDetail',
        component: () => import('views/order/Detail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'retail',
        name:'retail',
        component: () => import('views/retail/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'product',
        name:'product',
        component: () => import('views/product/Index'),
        meta:{
          title:'拓客商圈'
        }
      },
      {
        path: 'prodetail',
        name:'prodetail',
        component: () => import('views/product/Detail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'detail',
        name:'detail',
        component: () => import('views/product/ProductDetail'),
        meta:{
          title:'商家详情'
        }
      },
      {
        path: 'choosepro',
        name:'choosepro',
        component: () => import('views/product/Choose'),
        meta:{
          title:'产品详情'
        }
      },
      {
        path: 'listpro',
        name:'listpro',
        component: () => import('views/product/ListPro'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'listDetail',
        name:'listDetail',
        component: () => import('views/product/ListDetail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'yespro',
        name:'yespro',
        component: () => import('views/product/Yespro'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'address',
        name:'address',
        component: () => import('views/product/Address'),
        meta:{
          title:'选择地址'
        }
      },
      {
        path: 'malladdress',
        name:'malladdress',
        component: () => import('views/product/Malladdress'),
        meta:{
          title:'商家地址围栏设置'
        }
      },
      {
        path: 'addmalladdress',
        name:'addmalladdress',
        component: () => import('views/product/Addmalladdress'),
        meta:{
          title:'商家地址围栏设置'
        }
      },
      {
        path: 'mallshare',
        name:'mallshare',
        component: () => import('views/product/Share'),
        meta:{
          title:'推荐有礼'
        }
      },
      {
        path: 'payment',
        name:'payment',
        component: () => import('views/product/Payment'),
        meta:{
          title:'确认订单'
        }
      },
      {
        path: 'coupon',
        name:'coupon',
        component: () => import('views/product/Coupon'),
        meta:{
          title:'我的优惠劵'
        }
      },
      {
        path: 'porder',
        name:'porder',
        component: () => import('views/product/Order'),
        meta:{
          title:'商品订单'
        }
      },

      {
        path: 'pcode',
        name:'pcode',
        component: () => import('views/product/Code'),
        meta:{
          title:'订单核销'
        }
      },
      {
        path: 'viporder',
        name:'viporder',
        component: () => import('views/product/Viporder'),
        meta:{
          title:'Svip订单'
        }
      },
      {
        path: 'home',
        name:'home',
        component: () => import('views/product/Homes'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'addSave',
        name:'addSave',
        component: () => import('views/product/Add'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'sorder',
        name:'sorder',
        component: () => import('views/product/Sorder'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'source',
        name:'source',
        component: () => import('views/product/Source'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'manage',
        name:'manage',
        component: () => import('views/product/Manage'),
        meta:{
          title:'商家管理'
        }
      },
      {
        path: 'arrival',
        name:'arrival',
        component: () => import('views/product/Arrival'),
        meta:{
          title:'商家管理'
        }
      },
      {
        path: 'attribute',
        name:'attribute',
        component: () => import('views/product/Attribute'),
        meta:{
          title:'商家属性分类'
        }
      },

      {
        path: 'couponlist',
        name:'couponlist',
        component: () => import('views/product/Couponlist'),
        meta:{
          title:'优惠劵管理'
        }
      },
      {
        path: 'coupondraw',
        name:'coupondraw',
        component: () => import('views/product/Coupondraw'),
        meta:{
          title:'优惠劵领取情况'
        }
      },
      {
        path: 'couponadd',
        name:'couponadd',
        component: () => import('views/product/Couponadd'),
        meta:{
          title:'创建优惠劵'
        }
      },
      {
        path: 'managepro',
        name:'managepro',
        component: () => import('views/product/Product'),
        meta:{
          title:'产品管理'
        }
      },
      {
        path: 'productadd',
        name:'productadd',
        component: () => import('views/product/Productadd'),
        meta:{
          title:'发行产品'
        }
      },
      {
        path: 'wallet',
        name:'wallet',
        component: () => import('views/product/Wallet'),
        meta:{
          title:'提现'
        }
      },

      {
        path: 'mallstaff',
        name:'mallstaff',
        component: () => import('views/product/Staff'),
        meta:{
          title:'商家会员管理'
        }
      },
      {
        path: 'vipadd',
        name:'vipadd',
        component: () => import('views/product/Vipadd'),
        meta:{
          title:'SVIP创建'
        }
      },


      {
        path: 'point',
        name:'point',
        component: () => import('views/product/Point'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'broker',
        name:'broker',
        component: () => import('views/cash/Broker'),
        meta:{
          title:'平台通用劵'
        }
      },
      {
        path: 'write',
        name:'write',
        component: () => import('views/write/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'wDetail',
        name:'wDetail',
        component: () => import('views/write/Detail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'analysis',
        name:'analysis',
        component: () => import('views/write/Analysis'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'agree',
        name:'agree',
        component: () => import('views/write/Agree'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'read',
        name:'read',
        component: () => import('views/write/Read'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'record',
        name:'record',
        component: () => import('views/write/Record'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'share',
        name:'share',
        component: () => import('views/write/Share'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'video',
        name:'video',
        component: () => import('views/video/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'play',
        name:'play',
        component: () => import('views/video/Play'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'cart',
        name:'cart',
        component: () => import('views/cart/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'choose',
        name:'choose',
        component: () => import('views/cart/Choose'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'login',
        name:'login',
        component: () => import('views/login/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'indy',
        name:'indy',
        component: () => import('views/Indy/Index'),
        meta:{
          title:'个人信息'
        }
      },
      {
        path: 'avatar',
        name:'avatar',
        component: () => import('views/Indy/Avatar'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'nick',
        name:'nick',
        component: () => import('views/Indy/Nick'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'business',
        name:'business',
        component: () => import('views/Indy/Business'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'pwd',
        name:'pwd',
        component: () => import('views/Indy/Password'),
        meta:{
          title:'修改密码'
        }
      },
      {
        path: 'intro',
        name:'intro',
        component: () => import('views/intro/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'brand',
        name:'brand',
        component: () => import('views/brand/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'edit',
        name:'edit',
        component: () => import('views/edit/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'eDetail',
        name:'eDetail',
        component: () => import('views/edit/Detail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'posters',
        name:'posters',
        component: () => import('views/posters/Index'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'postDetail',
        name:'postDetail',
        component: () => import('views/posters/Detail'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'add',
        name:'add',
        component: () => import('views/posters/Add'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'join',
        name:'join',
        component: () => import('views/posters/Join'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'lock',
        name:'lock',
        component: () => import('views/lock/Index'),
        meta:{
          title:'茶室列表'
        }
      },
      {
        path: 'lockDetail',
        name:'lockDetail',
        component: () => import('views/lock/Detail'),
        meta:{
          title:'茶室详情'
        }
      },
      {
        path: 'qrOrder',
        name:'qrOrder',
        component: () => import('views/lock/Order'),
        meta:{
          title:'场所预定'
        }
      },
      {
        path: 'lockPay',
        name:'lockPay',
        component: () => import('views/lock/Payment'),
        meta:{
          title:'空间订单'
        }
      },
      {
        path: 'lockYes',
        name:'lockYes',
        component: () => import('views/lock/Yes'),
        meta:{
          title:'我的订单'
        }
      },
      {
        path: 'opendoc',
        name:'opendoc',
        component: () => import('views/lock/OpenDock'),
        meta:{
          title:'景区一码通'
        }
      },
      {
        path: 'pwdlock',
        name:'pwdlock',
        component: () => import('views/lock/PwdLock'),
        meta:{
          title:'查看密码'
        }
      },

      {
        path: 'lockpark',
        name:'lockpark',
        component: () => import('views/lock/Park'),
        meta:{
          title:'入住抵扣'
        }
      },

      {
        path: 'apply',
        name:'apply',
        component: () => import('views/lock/Applys'),
        meta:{
          title:'业主加盟'
        }
      },
      {
        path: 'owner',
        name:'owner',
        component: () => import('views/lock/Owner'),
        meta:{
          title:'业主数据管理'
        }
      },
      {
        path: 'userlock',
        name:'userlock',
        component: () => import('views/lock/Lock'),
        meta:{
          title:'业主茶室管理'
        }
      },

      {
        path: 'water',
        name:'water',
        component: () => import('views/water/Index'),
        meta:{
          title:'配送员加盟申请'
        }
      },
      {
        path: 'hall',
        name:'hall',
        component: () => import('views/water/Wtake'),
        meta:{
          title:'订单大厅'
        }
      },
      {
        path: 'waterdetail',
        name:'waterdetail',
        component: () => import('views/water/Detail'),
        meta:{
          title:'订单详情'
        }
      },
      {
        path: 'deliver',
        name:'deliver',
        component: () => import('views/water/Deliver'),
        meta:{
          title:'我的客户'
        }
      },
      {
        path: 'counts',
        name:'counts',
        component: () => import('views/water/Counts'),
        meta:{
          title:'财务情况'
        }
      },
      {
        path: 'wcode',
        name:'wcode',
        component: () => import('views/water/Code'),
        meta:{
          title:'确认收货'
        }
      },

      {
        path: 'qrcode',
        name:'qrcode',
        component: () => import('views/water/Qrcode'),
        meta:{
          title:'我要分享'
        }
      },


      {
        path: 'cleaner',
        name:'cleaner',
        component: () => import('views/cleaner/Apply'),
        meta:{
          title:'清洁工加盟'
        }
      },
      {
        path: 'take',
        name:'take',
        component: () => import('views/cleaner/Index'),
        meta:{
          title:'接单'
        }
      },
      {
        path: 'result',
        name:'result',
        component: () => import('views/cleaner/Result'),
        meta:{
          title:'打扫结果提交'
        }
      },



      {
        path: 'clust',
        name:'clust',
        component: () => import('views/clust/Index'),
        meta:{
          title:'锁群列表'
        }
      },

      {
        path: 'clustDetail',
        name:'clustDetail',
        component: () => import('views/clust/Detail'),
        meta:{
          title:'详情'
        }
      },

      {
        path: 'clustOrder',
        name:'clustOrder',
        component: () => import('views/clust/Order'),
        meta:{
          title:'开锁订单'
        }
      },

      {
        path: 'clustManage',
        name:'clustManage',
        component: () => import('views/clust/Manage'),
        meta:{
          title:'业主管理'
        }
      },

      {
        path: 'farm',
        name:'farm',
        component: () => import('views/farm/Index'),
        meta:{
          title:'菜园列表'
        }
      },

      {
        path: 'farmdetail',
        name:'farmdetail',
        component: () => import('views/farm/Detail'),
        meta:{
          title:'详情'
        }
      },
      {
        path: 'comment',
        name:'comment',
        component: () => import('views/farm/Comment'),
        meta:{
          title:'我要评价'
        }
      },
      {
        path: 'reply',
        name:'reply',
        component: () => import('views/farm/Reply'),
        meta:{
          title:'回复'
        }
      },
      {
        path: 'log',
        name:'log',
        component: () => import('views/farm/Log'),
        meta:{
          title:'发表日志'
        }
      },
      {
        path: 'shop',
        name:'shop',
        component: () => import('views/farm/Shop'),
        meta:{
          title:'商家店铺'
        }
      },
      {
        path: 'shopdetail',
        name:'shopdetail',
        component: () => import('views/farm/Shopdetail'),
        meta:{
          title:'商家详情'
        }
      },
      {
        path: 'sprodetail',
        name:'sprodetail',
        component: () => import('views/farm/Prodetail'),
        meta:{
          title:'商品详情'
        }
      },
      {
        path: 'spayment',
        name:'spayment',
        component: () => import('views/farm/Payment'),
        meta:{
          title:'购买'
        }
      },
      {
        path: 'saddress',
        name:'saddress',
        component: () => import('views/farm/Address'),
        meta:{
          title:'收货地址'
        }
      },
      {
        path: 'sadd',
        name:'sadd',
        component: () => import('views/farm/Add'),
        meta:{
          title:'收货地址'
        }
      },
      {
        path: 'sapply',
        name:'sapply',
        component: () => import('views/farm/Apply'),
        meta:{
          title:'店铺申请'
        }
      },
      {
        path: 'saddpro',
        name:'saddpro',
        component: () => import('views/farm/Addpro'),
        meta:{
          title:'商品发布'
        }
      },
      {
        path: 'farmorder',
        name:'farmorder',
        component: () => import('views/farm/Order'),
        meta:{
          title:'菜园订单'
        }
      },


      {
        path: 'lockcard',
        name:'lockcard',
        component: () => import('views/card/Index'),
        meta:{
          title:'空间一卡通'
        }
      },

      {
        path: 'lockcpay',
        name:'lockcpay',
        component: () => import('views/card/Payment'),
        meta:{
          title:'购卡详情'
        }
      },
      {
        path: 'lockorder',
        name:'lockorder',
        component: () => import('views/card/Order'),
        meta:{
          title:'我的空间卡'
        }
      },
      {
        path: 'lockcard1',
        name:'lockcard1',
        component: () => import('views/card/card'),
        meta:{
          title:'空间分布区'
        }
      },
      {
        path: 'receive',
        name:'receive',
        component: () => import('views/card/Receive'),
        meta:{
          title:'领取空间卡'
        }
      },


      {
        path: 'cardcode',
        name:'cardcode',
        component: () => import('views/card/Code'),
        meta:{
          title:'扫码绑卡'
        }
      },

      {
        path: 'store',
        name:'store',
        component: () => import('views/store/Index'),
        meta:{
          title:'物品列表'
        }
      },


      {
        path: 'storetotal',
        name:'storetotal',
        component: () => import('views/store/Total'),
        meta:{
          title:'订单统计'
        }
      },

      {
        path: 'storeDetail',
        name:'storeDetail',
        component: () => import('views/store/Detail'),
        meta:{
          title:'物品详情'
        }
      },

      {
        path: 'storeOrder',
        name:'storeOrder',
        component: () => import('views/store/Order'),
        meta:{
          title:'物品订单'
        }
      },

      {
        path: 'goodsedit',
        name:'goodsedit',
        component: () => import('views/store/Edit'),
        meta:{
          title:'物品编辑'
        }
      },

      {
        path: 'ware',
        name:'ware',
        component: () => import('views/store/Ware'),
        meta:{
          title:'物品验收'
        }
      },
      {
        path: 'warestore',
        name:'warestore',
        component: () => import('views/store/Warestore'),
        meta:{
          title:'查看验收结果'
        }
      },
      {
        path: 'goods',
        name:'goods',
        component: () => import('views/store/Goods'),
        meta:{
          title:'管理员物品列表'
        }
      },
      {
        path: 'storeadd',
        name:'storeadd',
        component: () => import('views/store/Add'),
        meta:{
          title:'物品添加'
        }
      },

      {
        path: 'storeManage',
        name:'storeManage',
        component: () => import('views/store/Manage'),
        meta:{
          title:'物品管理员'
        }
      },

      {
        path: 'goodsorder',
        name:'goodsorder',
        component: () => import('views/store/Goodsorder'),
        meta:{
          title:'管理员物品订单'
        }
      },

      {
        path: 'addstore',
        name:'addstore',
        component: () => import('views/store/Addstore'),
        meta:{
          title:'仓库申请'
        }
      },

      {
        path: 'storeuser',
        name:'storeuser',
        component: () => import('views/store/User'),
        meta:{
          title:'管理员列表'
        }
      },
      {
        path: 'adduser',
        name:'adduser',
        component: () => import('views/store/Adduser'),
        meta:{
          title:'添加管理员'
        }
      },
      {
        path: 'yunstore',
        name:'yunstore',
        component: () => import('views/store/Store'),
        meta:{
          title:'云仓库'
        }
      },
      {
        path: 'staff',
        name:'staff',
        component: () => import('views/store/Staff'),
        meta:{
          title:'员工管理'
        }
      },
      {
        path: 'addstaff',
        name:'addstaff',
        component: () => import('views/store/Addstaff'),
        meta:{
          title:'添加员工'
        }
      },

      {
        path: 'sms',
        name:'sms',
        component: () => import('views/sms/Index'),
        meta:{
          title:'消息提醒开通'
        }
      },

      {
        path: 'smsdetail',
        name:'smsdetail',
        component: () => import('views/sms/Detail'),
        meta:{
          title:'消息提醒开通'
        }
      },

      {
        path: 'pushOrder',
        name:'pushOrder',
        component: () => import('views/sms/Order'),
        meta:{
          title:'我的订单'
        }
      },

      {
        path: 'pushScenic',
        name:'pushScenic',
        component: () => import('views/sms/Scenic'),
        meta:{
          title:'景区广告'
        }
      },
      {
        path: 'pushStaff',
        name:'pushStaff',
        component: () => import('views/sms/Staff'),
        meta:{
          title:'消息发送详情'
        }
      },
      {
        path: 'batch',
        name:'batch',
        component: () => import('views/sms/Batch'),
        meta:{
          title:'批量推送'
        }
      },
      {
        path: 'noty',
        name:'noty',
        component: () => import('views/sms/Noty'),
        meta:{
          title:'公告'
        }
      },
      {
        path: 'follow',
        name:'follow',
        component: () => import('views/mine/Follow'),
        meta:{
          title:'关注有礼'
        }
      },
      {
        path: 'mwallet',
        name:'mwallet',
        component: () => import('views/mine/Wallet'),
        meta:{
          title:'提现'
        }
      },
      {
        path: 'large',
        name:'large',
        component: () => import('views/mine/Large'),
        meta:{
          title:'大额提现申请'
        }
      },
      {
        path: 'larger',
        name:'larger',
        component: () => import('views/mine/Larger'),
        meta:{
          title:'提现审批'
        }
      },
      {
        path: 'golarger',
        name:'golarger',
        component: () => import('views/mine/Golarger'),
        meta:{
          title:'提现审批'
        }
      },
      {
        path: 'income',
        name:'income',
        component: () => import('views/mine/Income'),
        meta:{
          title:'收入明细'
        }
      },
      {
        path: 'mcoupon',
        name:'mcoupon',
        component: () => import('views/mine/Coupon'),
        meta:{
          title:'我的优惠劵'
        }
      },
      {
        path: 'tindex',
        name:'tindex',
        component: () => import('views/ticket/Index'),
        meta:{
          title:'景区门票'
        }
      },
      {
        path: 'tkdetail',
        name:'tkdetail',
        component: () => import('views/ticket/Detail'),
        meta:{
          title:'景区'
        }
      },
      {
        path: 'tkscenic',
        name:'tkscenic',
        component: () => import('views/ticket/Scenic'),
        meta:{
          title:'景区简介'
        }
      },
      {
        path: 'tkpayment',
        name:'tkpayment',
        component: () => import('views/ticket/Payment'),
        meta:{
          title:'确认订单'
        }
      },
      {
        path: 'tkapply',
        name:'tkapply',
        component: () => import('views/ticket/Apply'),
        meta:{
          title:'分销认证'
        }
      },
      {
        path: 'rose',
        name:'rose',
        component: () => import('views/ticket/Rose'),
        meta:{
          title:'区域代理认证'
        }
      },
      {
        path: 'distribution',
        name:'distribution',
        component: () => import('views/ticket/Distribution'),
        meta:{
          title:'我的分销'
        }
      },
      {
        path: 'crowd',
        name:'crowd',
        component: () => import('views/crowd/Index'),
        meta:{
          title:'咖啡机设备列表'
        }
      },
      {
        path: 'crowd-detail',
        name:'crowd-detail',
        component: () => import('views/crowd/Detail'),
        meta:{
          title:'设备详情'
        }
      },
      {
        path: 'crowdinfo',
        name:'crowdinfo',
        component: () => import('views/crowd/Crowd'),
        meta:{
          title:'详情介绍'
        }
      },
      {
        path: 'crowd-share',
        name:'crowd-share',
        component: () => import('views/crowd/Share'),
        meta:{
          title:'入股明细'
        }
      },
      {
        path: 'turnover',
        name:'turnover',
        component: () => import('views/crowd/Turnover'),
        meta:{
          title:'设备流水'
        }
      },
      {
        path: 'ctotal',
        name:'ctotal',
        component: () => import('views/crowd/Total'),
        meta:{
          title:'当天数据统计'
        }
      },
      {
        path: 'overtotal',
        name:'overtotal',
        component: () => import('views/crowd/Overtotal'),
        meta:{
          title:'数据统计'
        }
      },
      {
        path: 'crowd-payment',
        name:'crowd-payment',
        component: () => import('views/crowd/Payment'),
        meta:{
          title:'确认支付'
        }
      },
      {
        path: 'crowd-success',
        name:'crowd-success',
        component: () => import('views/crowd/Paysuccess'),
        meta:{
          title:'支付成功'
        }
      },
      {
        path: 'crowdorder',
        name:'crowdorder',
        component: () => import('views/crowd/Order'),
        meta:{
          title:'订单返现'
        }
      },
      {
        path: 'menber',
        name:'menber',
        component: () => import('views/crowd/Menber'),
        meta:{
          title:'会员管理'
        }
      },
      {
        path: 'paymenber',
        name:'paymenber',
        component: () => import('views/crowd/Paymenber'),
        meta:{
          title:'开通会员'
        }
      },
      {
        path: 'mdetail',
        name:'mdetail',
        component: () => import('views/crowd/Mdetail'),
        meta:{
          title:'开通会员'
        }
      },

      {
        path: 'mreceive',
        name:'mreceive',
        component: () => import('views/crowd/Receive'),
        meta:{
          title:'领取会员'
        }
      },

      {
        path: 'mpark',
        name:'mpark',
        component: () => import('views/crowd/Park'),
        meta:{
          title:'领票入口'
        }
      },


      {
        path: 'import',
        name:'import',
        component: () => import('views/import/Index'),
        meta:{
          title:'入园申请'
        }
      },
      {
        path: 'imdetail',
        name:'imdetail',
        component: () => import('views/import/Detail'),
        meta:{
          title:'入园申请'
        }
      },
      {
        path: 'imsuccess',
        name:'imsuccess',
        component: () => import('views/import/Paysuccess'),
        meta:{
          title:'出票口'
        }
      },
      {
        path: 'imorder',
        name:'imorder',
        component: () => import('views/import/Order'),
        meta:{
          title:'出票列表'
        }
      },
      {
        path: 'imanage',
        name:'imanage',
        component: () => import('views/import/Manage'),
        meta:{
          title:'出票口'
        }
      },
      {
        path: 'clearer',
        name:'clearer',
        component: () => import('views/crowd/Clearer'),
        meta:{
          title:'咖啡机设备管理'
        }
      },
      {
        path: 'goclearer',
        name:'goclearer',
        component: () => import('views/crowd/Goclearer'),
        meta:{
          title:'补充材料认证'
        }
      },
      {
        path: 'cresult',
        name:'cresult',
        component: () => import('views/crowd/Result'),
        meta:{
          title:'管理员审核'
        }
      },
      {
        path: 'cserver',
        name:'cserver',
        component: () => import('views/crowd/Server'),
        meta:{
          title:'场地方管理员'
        }
      },
      {
        path: 'chicken',
        name:'chicken',
        component: () => import('views/chicken/Index'),
        meta:{
          title:'走地鸡养殖场'
        }
      },
      {
        path: 'cdetail',
        name:'cdetail',
        component: () => import('views/chicken/Detail'),
        meta:{
          title:'详情'
        }
      },
      {
        path: 'cpayment',
        name:'cpayment',
        component: () => import('views/chicken/Payment'),
        meta:{
          title:'立即支付'
        }
      },
      {
        path: 'corder',
        name:'corder',
        component: () => import('views/chicken/Order'),
        meta:{
          title:'我的订单'
        }
      },
      {
        path: 'movies',
        name:'movies',
        component: () => import('views/movies/Index'),
        meta:{
          title:'电影票'
        }
      },
      {
        path: 'cinema',
        name:'cinema',
        component: () => import('views/movies/Detail'),
        meta:{
          title:'影票详情'
        }
      },
      {
        path: 'seats',
        name:'seats',
        component: () => import('views/movies/Seats'),
        meta:{
          title:'选座'
        }
      },
      {
        path: 'cinemalist',
        name:'cinemalist',
        component: () => import('views/movies/Cinema'),
        meta:{
          title:'影票列表'
        }
      },
      {
        path: 'moviesdetail',
        name:'moviesdetail',
        component: () => import('views/movies/Movie'),
        meta:{
          title:'电影详情'
        }
      },
      {
        path: 'moviesorder',
        name:'moviesorder',
        component: () => import('views/movies/Order'),
        meta:{
          title:'确认付款'
        }
      },
      {
        path: 'msorder',
        name:'msorder',
        component: () => import('views/movies/Morder'),
        meta:{
          title:'订单管理'
        }
      },
      {
        path: 'mcode',
        name:'mcode',
        component: () => import('views/movies/Code'),
        meta:{
          title:'订单详情'
        }
      },
      {
        path: 'citys',
        name:'citys',
        component: () => import('views/movies/Citys'),
        meta:{
          title:'发现周边'
        }
      },

      {
        path: 'mscenic',
        name:'mscenic',
        component: () => import('views/movies/Scenic'),
        meta:{
          title:'景区详情'
        }
      },
      {
        path: 'moviescoupon',
        name:'moviescoupon',
        component: () => import('views/movies/Coupon'),
        meta:{
          title:'优惠劵'
        }
      },
      {
        path: 'coupondetail',
        name:'coupondetail',
        component: () => import('views/movies/Coupondetail'),
        meta:{
          title:'电影优惠劵'
        }
      },
      {
        path: 'couponorder',
        name:'couponorder',
        component: () => import('views/movies/Corder'),
        meta:{
          title:'优惠劵订单'
        }
      },

      {
        path: 'mpay',
        name:'mpay',
        component: () => import('views/movies/Payment'),
        meta:{
          title:'充值'
        }
      },
      {
        path: 'journey',
        name:'journey',
        component: () => import('views/movies/Journey'),
        meta:{
          title:'我的签到记录'
        }
      },
      {
        path: 'pdeliver',
        name:'pdeliver',
        component: () => import('views/product/Deliver'),
        meta:{
          title:'配送员设置'
        }
      },
      {
        path: 'pdeliveradd',
        name:'pdeliveradd',
        component: () => import('views/product/Deliveradd'),
        meta:{
          title:'新增配送员'
        }
      },
      {
        path: 'pdeliverorder',
        name:'pdeliverorder',
        component: () => import('views/product/Deliverorder'),
        meta:{
          title:'配送员订单'
        }
      },
      {
        path: 'pdeliverdetail',
        name:'pdeliverdetail',
        component: () => import('views/product/Deliverdetail'),
        meta:{
          title:'配送员订单详情'
        }
      },
      {
        path: 'pdeliveruser',
        name:'pdeliveruser',
        component: () => import('views/product/Deliveruser'),
        meta:{
          title:''
        }
      },
      {
        path: 'related',
        name:'related',
        component: () => import('views/product/Related'),
        meta:{
          title:'详情'
        }
      },
      {
        path: 'luggage',
        name:'luggage',
        component: () => import('views/luggage/Index'),
        meta:{
          title:'行李快送集中点'
        }
      },
      {
        path: 'lugpro',
        name:'lugpro',
        component: () => import('views/luggage/Product'),
        meta:{
          title:'行李快送集中点'
        }
      },
      {
        path: 'ldetail',
        name:'ldetail',
        component: () => import('views/luggage/Detail'),
        meta:{
          title:'行李快送详情'
        }
      },
      {
        path: 'lpayment',
        name:'lpayment',
        component: () => import('views/luggage/Payment'),
        meta:{
          title:'确认付款'
        }
      },
      {
        path: 'lorder',
        name:'lorder',
        component: () => import('views/luggage/Order'),
        meta:{
          title:'我的订单'
        }
      },
      {
        path: 'lhall',
        name:'lhall',
        component: () => import('views/luggage/Hall'),
        meta:{
          title:'接单大厅'
        }
      },
      {
        path: 'lcode',
        name:'lcode',
        component: () => import('views/luggage/Code'),
        meta:{
          title:'订单详情'
        }
      },
      {
        path: 'tickle',
        name:'tickle',
        component: () => import('views/tickle/Index'),
        meta:{
          title:'拍一拍集合啦'
        }
      },
      {
        path: 'recharge',
        name:'recharge',
        component: () => import('views/mine/Recharge'),
        meta:{
          title:'现金充值'
        }
      },
      {
        path: 'demo',
        name:'demo',
        component: () => import('views/demo/Index'),
        meta:{
          title:'宝地一卡通'
        }
      },
      {
        path: 'my',
        name:'my',
        component: () => import('views/demo/My'),
        meta:{
          title:'我的'
        }
      },
      {
        path: 'parking',
        name:'parking',
        component: () => import('views/demo/Parking'),
        meta:{
          title:'停车缴费'
        }
      },
      {
        path: 'none',
        name:'none',
        component: () => import('views/demo/None'),
        meta:{
          title:'停车缴费'
        }
      },
      {
        path: 'canteen',
        name:'canteen',
        component: () => import('views/demo/Canteen'),
        meta:{
          title:'智慧食堂'
        }
      },
      {
        path: 'mallapply',
        name:'mallapply',
        component: () => import('views/product/Apply'),
        meta:{
          title:'补货申请'
        }
      },
      {
        path: 'mallapplyadd',
        name:'mallapplyadd',
        component: () => import('views/product/Applyadd'),
        meta:{
          title:'补货申请'
        }
      },

      {
        path: 'gathercode',
        name:'gathercode',
        component: () => import('views/gather/Code'),
        meta:{
          title:'激活悠乐聚卡'
        }
      },
      {
        path: 'gatherorder',
        name:'gatherorder',
        component: () => import('views/gather/Order'),
        meta:{
          title:'激活悠乐聚卡'
        }
      },
      {
        path: 'gatherdetail',
        name:'gatherdetail',
        component: () => import('views/gather/Detail'),
        meta:{
          title:'激活悠乐聚卡'
        }
      },
      {
        path: 'gathermanage',
        name:'gathermanage',
        component: () => import('views/gather/Manage'),
        meta:{
          title:'悠乐聚卡管理'
        }
      },
      {
        path: 'gathercard',
        name:'gathercard',
        component: () => import('views/gather/Card'),
        meta:{
          title:'悠乐聚卡管理'
        }
      },
      {
        path: 'gathernum',
        name:'gathernum',
        component: () => import('views/gather/Scenic'),
        meta:{
          title:'悠乐聚卡管理'
        }
      },
      {
        path: 'gatherscenic',
        name:'gatherscenic',
        component: () => import('views/gather/Index'),
        meta:{
          title:'悠乐聚卡'
        }
      },
      {
        path: 'gathermake',
        name:'gathermake',
        component: () => import('views/gather/Make'),
        meta:{
          title:'悠乐聚卡'
        }
      },
      {
        path: 'schedule',
        name:'schedule',
        component: () => import('views/gather/Schedule'),
        meta:{
          title:'悠乐聚卡'
        }
      },
      {
        path: 'cancel',
        name:'cancel',
        component: () => import('views/gather/Cancel'),
        meta:{
          title:'悠乐聚卡'
        }
      },

      {
        path: 'juka',
        name:'juka',
        component: () => import('views/juka/index/Index'),
        meta:{
          title:'悠乐聚卡'
        }
      },
    ]
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
